import React from 'react';
import { Container, Box } from '@mui/material';
import HeroHeader from '../components/HeroHeader';
import BookingBg from '../assets/images/header-backgrounds/background2.png';

const BookingPage = () => {
  return (
    <>
      <HeroHeader 
        title="Book Your Service"
        backgroundImage={BookingBg}
      />
      <Container maxWidth="xl" sx={{ py: 8, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center',
          alignItems: 'flex-start',
          width: '100%'
        }}>
          <Box 
            sx={{ 
              width: '100%',
              '& iframe': {
                width: '100% !important',
                height: '1000px !important',
                border: 'none'
              }
            }}
          >
            <iframe 
              id="markate-widget-booking-iframe" 
              src="https://clienthub.getjobber.com/booking/a1a0334a-699e-4299-b9ed-cc31632ccf3c" 
              width="100%" 
              height="1000" 
              scrolling="yes" 
              frameBorder="0" 
              allowTransparency="true" 
              style={{ border: 'none' }}
              title="Hawkins Carpet Cleaning Booking Widget"
            />
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default BookingPage; 